import { render, staticRenderFns } from "./footerDesktop.vue?vue&type=template&id=776c14f6&scoped=true&"
import script from "./footerDesktop.vue?vue&type=script&lang=js&"
export * from "./footerDesktop.vue?vue&type=script&lang=js&"
import style0 from "./footerDesktop.vue?vue&type=style&index=0&id=776c14f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776c14f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VParallax,VRow})
